//perfumeria2023

$(document).ready(function () {
  //load products
  $('.product-grid-container').on('click', '#load-next', function () {
    loadProducts($(this), '');
  }).on('click', '#load-prev', function () {
    loadProducts($(this), 'prev');
  });

  $('.lp_recomended').on('click', '.link-button', function (e) {
    e.preventDefault();
    $('.lp_recomended').addClass('open');
  });

  if ($("#create_customer").length == 1) {
    let cookie = getCookie('__ca__chat');
    $('input[name="customer[note][ca_chat]"]').val(cookie);
  }
  $('.variant_more').on('click', function () {
    $(this).parent().prev('.option-kolor').toggleClass('open');
    $(this).remove();
    //$(this).parent().prev('.option-kolor').slideDown();
  });

  // var lpperf = $('.lp-perfumy deferred-media');
  // if(lpperf.length > 0) {  
  //   lpperf[0].loadContent();
  //   setTimeout(function() {
  //     lpperf.find('video')[0].play();
  //   }, 2000);
  // }
});

//zmiana zgody cookies - link w menu Shopify z hashem #ustawienia-cookies (menu nie przyjmuje javascript:)
//bez Cookiebota (np. zablokowany) link prowadzi normalnie pod swoj adres
$(document).on('click', 'a[href$="#ustawienia-cookies"]', function (e) {
  if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
    e.preventDefault();
    window.Cookiebot.renew();
  }
});

$('.facet-checkbox a, .mobile-facets__label a').on('click', function (e) {
  e.preventDefault();
  $(this).closest('label').click();
});
//infinite scroll products on collection page
async function loadProducts(button, direction) {
  const buttonUrl = button.val();
  const sectionId = button.data('section-id');
  const url = window.location.origin + buttonUrl + '&section_id=' + sectionId;
  //console.log(buttonUrl, sectionId, url);

  button.attr('aria-disabled', true);
  button.addClass('loading');
  button.children('.loading-overlay__spinner').removeClass('hidden');

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
    const data = await response.text();
    //console.log(data);

    if (!data || data.length == 0) {
      button.attr('aria-disabled', false);
      button.removeClass('loading');
      button.children('.loading-overlay__spinner').addClass('hidden');
      throw new Error(`Wrong pagination response`);
    }

    const html = new DOMParser().parseFromString(data, 'text/html');
    var productsList = html.querySelectorAll('#product-grid .col');
    if (!productsList || productsList.length == 0) {
      button.attr('aria-disabled', false);
      button.removeClass('loading');
      button.children('.loading-overlay__spinner').addClass('hidden');
      throw new Error(`No products in pagination response`);
    }

    var pagination = html.querySelector(".pagination-wrapper .pagination");
    var nextURL = button.val();
    //const nextTitle = html.querySelector("#product-grid").dataset.nextTitle;

    if (direction == 'prev') {
      var prevPage = html.querySelector("#load-prev");
      if (prevPage) {
        button.replaceWith(prevPage);
      } else {
        button.remove();
      }
      $("#product-grid").prepend(productsList);
    } else {
      var nextPage = html.querySelector("#load-next");
      if (nextPage) {
        button.replaceWith(nextPage);
      } else {
        button.remove();
      }
      $("#product-grid").append(productsList);
    }

    $(".pagination-wrapper").html(pagination);
    window.history.pushState(false, false, nextURL);

    // if (document.title != nextTitle) {
    //   document.title = nextTitle;
    // }

    button.attr('aria-disabled', false);
    button.removeClass('loading');
    button.children('.loading-overlay__spinner').addClass('hidden');
  } catch (error) {
    console.error(error.message);
  }
}

//top announcement bar section animated
var aSect = document.querySelector('.announcement-bar__section');
if (aSect) {
  var aSectWidth = aSect.offsetWidth
  var aWrap = document.querySelector('.announcement-bar__wrapper');
  var aWrapContent = aWrap.innerHTML;
  for (var i = 0; i < 20; i++) {
    let aWrap1 = document.querySelector('.announcement-bar__wrapper');
    var aWrapContent1 = aWrap1.innerHTML;
    let wrapWidth = aWrap1.offsetWidth;

    if (wrapWidth < 2 * aSectWidth) {
      aWrap.innerHTML = aWrapContent1.concat(aWrapContent);
    } else {
      break;
    }
  }
}

var stopData = false;
//slider home
var swiperHomeSlider = new Swiper(".slider-home.swiper", {
  effect: 'slide',
  loop: false,
  speed: 300,
  simulateTouch: false,
  pagination: {
    el: '.slider-home .slider-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return `<span class="dot swiper-pagination-bullet">0${index + 1}</span>`;
    },
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  on: {
    init: function () {
      addViewPromo(this);
    },
    activeIndexChange: function () {
      addViewPromo(this);
    },
    transitionStart: function () {
      var prevSlide = this.slides[this.previousIndex];
      var prevSlideVideo = prevSlide.getElementsByTagName('video')[0];
      if (prevSlideVideo) {
        prevSlideVideo.pause();
      }

      this.pagination.el

      var activeSlide = this.slides[this.activeIndex];
      var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
      if (activeSlideVideo) {
        activeSlideVideo.currentTime = 0;
        activeSlideVideo.play();
      }

      var activeSlideText = activeSlide.querySelector('.slider-text');
      if (activeSlideText) {
        activeSlideText.prepend(this.pagination.el);
      }
    }
  }
});

function addViewPromo(slider) {
  if (slider.isEnd) {
    stopData = true;
  }
  if (stopData == false) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(JSON.parse(slider.slides[slider.activeIndex].dataset.layer));
  }
}

$('.slider-home.swiper .swiper-slide a').on('click', function () {
  var data = $(this).closest('.swiper-slide').data('layer');
  data.event = 'select_promotion';
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(data);
});

//slider producentów
var swiperVendors = new Swiper(".carousel-vendors .swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false
  // },
  breakpoints: {
    992: {
      slidesPerView: 7,
      spaceBetween: 0
    }
  }
});

//kopia sekcji 'logotypy producentów' do megamenu
//var request2 = new XMLHttpRequest();
//request2.addEventListener('load', handleResponse);
//request2.open('GET', '/?section_id=template--18164931920163__05287f66-fd11-4ed1-8196-7b54bbc3db4b', true);
//request2.send();

function handleResponse() {
  $('.megamenu__vendors-wrapper').html(this.responseText); //wgranie kopii sekcji do menu
  var swiperVendorsMenu = new Swiper(".megamenu__vendors-wrapper .carousel-vendors", { // reinicjalizacja slidera dla kopii w menu
    effect: 'slide',
    speed: 500,
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 16,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    breakpoints: {
      992: {
        slidesPerView: 7,
        spaceBetween: 5
      }
    }
  });
}

//slider kolekcji wyróżnionych
const swiperFeaturedCollection = document.querySelectorAll('.featured-slider');

swiperFeaturedCollection.forEach(el => {
  let inner = el.querySelector('.swiper');
  let scrollbar = el.querySelector('.swiper-scrollbar');
  let next = el.querySelector('.swiper-next');
  let prev = el.querySelector('.swiper-prev');

  new Swiper(inner, {
    effect: 'slide',
    speed: 500,
    loop: false,
    slidesPerView: 'auto',
    //spaceBetween: 16,
    //autoplay: {
    // delay: 5000,
    // disableOnInteraction: false
    //},
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
  });
});

//slider bloga home
var swiperFeaturedBlog = new Swiper(".featured-blog__list.swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.featured-blog .swiper-next',
    prevEl: '.featured-blog .swiper-prev',
  },
  //spaceBetween: 16,
  //autoplay: {
  // delay: 5000,
  // disableOnInteraction: false
  //},
});

var swiperCollageCollection = new Swiper(".collage-collection .swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.collage-collection .swiper-next',
    prevEl: '.collage-collection .swiper-prev',
  },
});

//slide miniatur produktu
var swiperThumbnailsGalleryEl = document.querySelector('section[id^="MainProduct-"] .media-gallery_thumbnails');
if (swiperThumbnailsGalleryEl) {
  var swiperThumbnailsGallery = new Swiper(swiperThumbnailsGalleryEl, {
    effect: 'slide',
    direction: 'vertical',
    speed: 500,
    loop: false,
    slidesPerView: 5,
    slidesPerGroup: 1,
    navigation: {
      nextEl: 'section[id^="MainProduct-"] .media-gallery_thumbnails .swiper-next',
      prevEl: 'section[id^="MainProduct-"] .media-gallery_thumbnails .swiper-prev',
    },
    spaceBetween: 12
  });
}
//slider główne zdjęcie produktu
var swiperMainGalleryEl = document.querySelector('section[id^="MainProduct-"] .media-gallery_main');
if (swiperMainGalleryEl) {
  var swiperMainGallery = new Swiper(swiperMainGalleryEl, {
    effect: 'fade',
    speed: 500,
    loop: false,
    slidesPerView: 1,
    thumbs: {
      swiper: swiperThumbnailsGallery,
    },
    navigation: {
      nextEl: 'section[id^="MainProduct-"] .media-gallery_main .swiper-next',
      prevEl: 'section[id^="MainProduct-"] .media-gallery_main .swiper-prev',
    },
    pagination: {
      el: '.slider-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="dot swiper-pagination-bullet">0${index + 1}</span>`;
      },
    }
  });
}
var quickThumbnailsGallery, quickMainGallery; // definicja zmiennych pod slider w quick-add

//slider sekcji informacyjnej
var swiperInfoBar = new Swiper(".shop-info-bar .swiper", {
  effect: 'slide',
  speed: 500,
  direction: 'vertical',
  loop: false,
  slidesPerView: 1,
  breakpoints: {
    992: {
      slidesPerView: 4,
      direction: 'horizontal'
    }
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false
  }
  //spaceBetween: 16,
  //autoplay: {
  // delay: 5000,
  // disableOnInteraction: false
  //},
});

//slider sekcji lp-look
var swiperLpLook = new Swiper(".lp_look .swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  grid: {
    rows: 3,
  },
  navigation: {
    nextEl: '.lp_look .swiper-next',
    prevEl: '.lp_look .swiper-prev',
  }
});

//slider sekcji lp-routine
var swiperLpRoutine = new Swiper(".lp_routine .swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.lp_routine .swiper-scrollbar',
    draggable: true,
  },
  navigation: {
    nextEl: '.lp_routine .swiper-next',
    prevEl: '.lp_routine .swiper-prev',
  },
  breakpoints: {
    992: {
      spaceBetween: 24,
    }
  }
});

//slider sekcji lp-components
var swiperLpComponents = new Swiper(".lp_components .swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.lp_components .swiper-scrollbar',
    draggable: true,
  },
  navigation: {
    nextEl: '.lp_components .swiper-next',
    prevEl: '.lp_components .swiper-prev',
  }
});
//slide menu

var mainMenu = $('.header__menu-main');
if (mainMenu) {
  var mainMenuWidth = mainMenu.outerWidth();
  var mainMenuList = $('.header__menu-main .menu_list');
  var arrowNext = $('.header__menu-main .menu-next');
  var arrowPrev = $('.header__menu-main .menu-prev')
  var mainMenuListWidth = mainMenuList.outerWidth();
  if (mainMenuListWidth > mainMenuWidth) {
    arrowNext.addClass('show');
  }
  //console.log(mainMenuWidth, mainMenuListWidth);

  var scrollList = parseInt($('.header__menu-main .menu_list').css("marginLeft").replace('px', ''));

  function menuRight(move) {
    mainMenuWidth = mainMenu.outerWidth();
    mainMenuListWidth = mainMenuList.outerWidth();
    scrollList = parseInt($('.header__menu-main .menu_list').css("marginLeft").replace('px', ''));

    if (move + mainMenuWidth - scrollList > mainMenuListWidth) {
      move = mainMenuListWidth - (mainMenuWidth - scrollList);
    }

    if (mainMenuWidth - scrollList >= mainMenuListWidth - move) {
      arrowNext.removeClass('show');
    }

    scrollList -= move;

    $('.header__menu-main .menu_list').css({ marginLeft: scrollList + 'px' });

    if (scrollList < 0) {
      arrowPrev.addClass('show');
    }
  }

  function menuLeft(move) {
    mainMenuWidth = mainMenu.outerWidth();
    mainMenuListWidth = mainMenuList.outerWidth();
    scrollList = parseInt($('.header__menu-main .menu_list').css("marginLeft").replace('px', ''));

    if (scrollList + move >= 0) {
      move = 0 - scrollList;
    }

    scrollList += move;

    $('.header__menu-main .menu_list').css({ marginLeft: scrollList + 'px' });

    if (scrollList == 0) {
      arrowPrev.removeClass('show');
    }
    if (scrollList <= 0) {
      arrowNext.addClass('show');
    }
  }


  var idx;

  $('.header__menu-main .menu-next').on('mouseenter', function (e) {
    idx = setInterval(() => {
      menuRight(30);
    }, 10);
  });

  $('.header__menu-main .menu-prev').on('mouseenter', function (e) {
    idx = setInterval(() => {
      menuLeft(30);
    }, 10);
  });

  $('.header__menu-main .menu-next, .header__menu-main .menu-prev').on('mouseleave', function (e) {
    clearInterval(idx);
  });

  $('.header__menu-main .menu-next').on('click', function (e) {
    menuRight(300);
  });

  $('.header__menu-main .menu-prev').on('click', function (e) {
    menuLeft(300);
  });
}

//main menu
// $('.header__menu-main .menu_list > .header__menu-item').on('mouseenter', function () {
//   $('.menu_list > .header__menu-item').removeClass('open');
//   $(this).addClass('open');
// });

// $('.header__menu-main').on('mouseleave', '.header__menu-item.open .megamenu__container', function () {
//   $(this).parents('.header__menu-item').removeClass('open');
// });

//ustawienie wysokości poszczególnych mega menu
resizedw();
var timer;
window.onresize = function () {
  clearTimeout(timer);
  timer = setTimeout(resizedw, 100);
};

function resizedw() {
  var isDesktop = window.matchMedia('(min-width: 992px)').matches; // na mobile te same listy są w drawerze
  $('.megamenu__list').each(function () {
    if (!isDesktop) {
      $(this).css('height', '');
      return;
    }
    var t = 0; // the height of the highest element (after the function runs)
    var t_elem;  // the highest element (after the function runs)
    $(this).children('li').each(function () {
      $this = $(this);
      if ($this.outerHeight() > t) {
        t_elem = this;
        t = $this.outerHeight();
      }
    });
    $(this).height(t + 75);
  });
}

var productInfo = document.querySelector('.product__info-container');

if (productInfo) {
  window.addEventListener('scroll', function (e) {
    var productInfoY = productInfo.getBoundingClientRect().bottom;
    //console.log(productInfoY);    
    if (productInfoY - 90 < 0) {
      productInfo.classList.add('sticky-form');
    } else {
      productInfo.classList.remove('sticky-form');
    }
  });
}


if (pageName == 'page.vendors' || pageName == 'list-collections') {
  //console.log('AZpageVendor');
  AZpageVendor();
}

function AZpageVendor() {
  // pages a-z vendors searching
  $('input.search-vendor').keyup(function () {
    var searchText = $(this).val();
    $(this).closest('section').find('.vendor-list li').each(function () {
      var currentLiText = $(this).text().toLowerCase(),
        showCurrentLi = currentLiText.indexOf(searchText.toLowerCase()) !== -1;
      if (showCurrentLi) {
        $(this).removeClass('d-none');
      } else {
        $(this).addClass('d-none');
      }
    });
    $('.vendor-list').each(function () {
      if ($(this).find('li:not(.d-none)').length == 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  });
}

//START podpowiedzi pola wyszukiwania 
var searchWords = document.getElementById('Search-In-Label-1').getAttribute('data-search-words');
setTimeout(function () {
  if (document.getElementById('Search-In-Modal-1').value == '') {
    var typewriter = new Typewriter('#Search-In-Label-1', {
      strings: searchWords.split(','),
      autoStart: true,
      loop: true
    });
  }
}, 2000);

document.getElementById('Search-In-Modal-1').addEventListener('focus', function () {
  if (typeof typewriter !== 'undefined')
    typewriter.stop();
  $('#Search-In-Label-1').text('Szukaj produktów');
});

document.getElementById('Search-In-Modal-1').addEventListener('focusout', function () {
  setTimeout(function () {
    if (document.getElementById('Search-In-Modal-1').value == '') {
      var typewriter = new Typewriter('#Search-In-Label-1', {
        strings: searchWords.split(','),
        autoStart: true,
        loop: true
      });
    }
  }, 1000);
});
//END podpowiedzi pola wyszukiwania

var deliveryTimer = document.querySelector(".delivery-timer-time");
var deliveryInterval;
if (deliveryTimer) {
  deliveryInterval = setInterval(() => {
    deliveryTime();
  }, 1000);
}

function deliveryTime() {
  let endtime = new Date();
  endtime.setHours(16, 0, 0, 0);
  let total = endtime - Date.parse(new Date());
  let seconds = Math.floor((total / 1000) % 60);
  let minutes = Math.floor((total / 1000 / 60) % 60);
  let hours = Math.floor((total / (1000 * 60 * 60)) % 24);

  if (hours >= 0 && minutes >= 0 && seconds >= 0) {
    deliveryTimer.innerHTML = (String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0"));
    document.querySelector(".delivery-timer").classList.remove("d-none");
  } else {
    clearInterval(deliveryInterval);
    document.querySelector(".delivery-timer").remove();
  }
}

//update cart drawer after disount code calculated
// window.addEventListener('sc:discount.calculated', (event) => {
//   let discount = JSON.parse(sessionStorage.getItem('scDiscountData')) || {};

//   if (discount.discount && parseFloat(discount.discount.amount) > 0) {
//     $('.totals__discount-amount').html(discount.discount.amount.replace('.',',') + ' zł');
//     $('.totals__discount').removeClass('d-none');
//     $('#code').val(discount.code).prop('readonly', true).after('<span class="sc_code-remove"><svg aria-hidden="true" focusable="false" class="icon icon-close" width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9995 0.585938L9.99946 8.58594L1.99946 0.585938L0.584961 1.99994L8.58546 9.99994L0.584961 17.9999L1.99946 19.4139L9.99946 11.4139L17.9995 19.4139L19.4135 17.9999L11.4135 9.99994L19.4135 1.99994L17.9995 0.585938Z" fill="currentColor"></path></svg></span>');
//     setTimeout(function(){
//       $('#code').val(discount.code);
//     },100);
//   } else {
//     $('.totals__discount-amount').html('-');
//     $('.totals__discount').addClass('d-none');
//     $('.sc_code-remove').remove();
//     $('#code').val('').prop('readonly', false);
//   }
//   //new CartDrawerItems().onCartUpdate();
// });

// window.addEventListener('sc:discount.init', (event) => {
//   let discount = JSON.parse(sessionStorage.getItem('scDiscountData')) || {};
//   if (discount.discount && parseFloat(discount.discount.amount)  > 0) {
//     $('#code').val(discount.code).prop('readonly', true).after('<span class="sc_code-remove"><svg aria-hidden="true" focusable="false" class="icon icon-close" width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9995 0.585938L9.99946 8.58594L1.99946 0.585938L0.584961 1.99994L8.58546 9.99994L0.584961 17.9999L1.99946 19.4139L9.99946 11.4139L17.9995 19.4139L19.4135 17.9999L11.4135 9.99994L19.4135 1.99994L17.9995 0.585938Z" fill="currentColor"></path></svg></span>');
//   }
// });

// window.addEventListener('sc:discount.remove', (event) => {
//   $('.sc_code-remove').remove();
//   $('#code').val('').prop('readonly', false);
// }); 

// $(document).on('click', '.sc_code-remove', function () {
//   let discount = JSON.parse(sessionStorage.getItem('scDiscountData')) || {};
//   window.DiscountHero.discount.remove(discount.code);
//   $('#code').val('');
// });

// function getCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// }

//discounts
var cart = $('cart-drawer-items').data('cartjson') || {};
var discount = JSON.parse(sessionStorage.getItem('checkoutDiscount')) || {};
var shippingDiscount = 0;
var product_collections = {};

initDiscount();

$(document).on('click', "#discount-button", function (e) {
  getDiscount();
});

$(document).on('click', '.discount-remove', function () {
  removeDiscount();
});

function getDiscount() {
  let inputCode = $("#inputDiscountCode").val();
  if (inputCode != '') {
    $("#inputDiscountCode").removeClass('is-invalid is-valid');
    $("#discount-button").prop('disabled', true);
    $('#discount-button span').toggleClass('d-none');

    let url = "/a/checkout/app/scripts/get_discount.php?d=" + inputCode;

    $.getJSON(url,
      '',
      function (response) {
        if (response.status === true) {
          discount = response;
        }
        applyDiscount();
      });
  }
}

async function applyCodeToShopify(reset = false) {
  if (reset == true) {
    return fetch(window.origin + "/discount/reset", { redirect: "manual" });
  } else {
    return fetch(window.origin + "/discount/" + discount.discount_code.code, { redirect: "manual" });
  }
}
async function updateCartDrawer(reset = false) {
  let result = await applyCodeToShopify(reset);
  new CartDrawerItems().onCartUpdate(); //odswiezenie wysuwanego koszyka

}

function applyDiscount() {
  calculateDiscount();

  if (discount.error == null && parseFloat(discount.value) < 0) { //(parseFloat(discount.value) < 0 || parseFloat(discount.shipping_discount) < 0)) 
    sessionStorage.setItem('checkoutDiscount', JSON.stringify(discount)); //zapis kodu do storage    
    updateCartDrawer(false);

    $("#inputDiscountCode ~ .valid-feedback").html('Zastosowano kod');
    $("#inputDiscountCode").addClass('is-valid').val(discount.discount_code.code).prop('readonly', true).after('<span class="discount-remove"><svg aria-hidden="true" focusable="false" class="icon icon-close" width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9995 0.585938L9.99946 8.58594L1.99946 0.585938L0.584961 1.99994L8.58546 9.99994L0.584961 17.9999L1.99946 19.4139L9.99946 11.4139L17.9995 19.4139L19.4135 17.9999L11.4135 9.99994L19.4135 1.99994L17.9995 0.585938Z" fill="currentColor"></path></svg></span>');
    $("#discount-button").prop('disabled', true);
    $('#discount-button span').toggleClass('d-none');
  } else {
    $("#inputDiscountCode ~ .invalid-feedback").html(discount.error);
    $("#inputDiscountCode").addClass('is-invalid');
    $("#discount-button").prop('disabled', false);
    $('#discount-button span').toggleClass('d-none');
  }
}

function removeDiscount() {
  sessionStorage.removeItem('checkoutDiscount'); //usunięcie kodu ze storage  
  updateCartDrawer(true); //odswiezenie wysuwanego koszyka
  discount = {};
  shippingDiscount = 0;

  $("#inputDiscountCode").removeClass('is-invalid is-valid').prop('readonly', false).val('');
  $("#discount-button").prop('disabled', false);
  $('.discount-remove').remove();
}

function sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = a[key]; var y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}

function initDiscount() {
  calculateDiscount();

  if (discount.error == null && parseFloat(discount.value) < 0) { //(parseFloat(discount.value) < 0 || parseFloat(discount.shipping_discount) < 0)) 
    $("#inputDiscountCode").prop('readonly', true).val(discount.discount_code.code).after('<span class="discount-remove"><svg aria-hidden="true" focusable="false" class="icon icon-close" width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9995 0.585938L9.99946 8.58594L1.99946 0.585938L0.584961 1.99994L8.58546 9.99994L0.584961 17.9999L1.99946 19.4139L9.99946 11.4139L17.9995 19.4139L19.4135 17.9999L11.4135 9.99994L19.4135 1.99994L17.9995 0.585938Z" fill="currentColor"></path></svg></span>');
    $("#discount-button").prop('disabled', true);
  }
}

function calculateDiscount() {
  if (discount.status != true) {
    //deactivateDiscount('Nie istnieje aktywny kod rabatowy o tej nazwie');      
    discount.error = 'Nie istnieje aktywny kod rabatowy o tej nazwie';
    return;
  }
  discount.error = null;
  shippingDiscount = 0;
  cart = $('cart-drawer-items').data('cartjson');
  product_collections = $('cart-drawer-items').data('collections');

  var discount_code = discount.discount_code;
  var price_rule = discount.price_rule;
  var entitledItems = [];
  var entitledItemsCount = 0;
  var entitledItemsPrice = 0;
  //var shippingCost = 8.99;

  if (price_rule.usage_limit != null && discount_code.usage_count >= price_rule.usage_limit) {
    discount.error = 'Wyczerpano limit użyć tego kodu';
    //deactivateDiscount('Wyczerpano limit użyć tego kodu');
    return;
  }

  if (price_rule.once_per_customer == true) {
    if (typeof customer !== 'undefined' && customer != null) {
      discount.used_codes = customer.codes;
      if (jQuery.inArray(discount_code.code, discount.used_codes) !== -1) {
        discount.error = 'Nie możesz użyć tego kodu ponownie';
        return;
      }
    } else {
      discount.error = 'Zaloguj się lub użyj tego kodu na kolejnym etapie';
      return;
    }
  }

  if ((price_rule.ends_at != null && Date.parse(price_rule.ends_at) <= Date.now()) ||
    (price_rule.starts_at != null && Date.parse(price_rule.starts_at) >= Date.now())) {
    discount.error = 'Nie istnieje aktywny kod rabatowy o tej nazwie';
    //deactivateDiscount('Nie istnieje aktywny kod rabatowy o tej nazwie');
    return;
  }

  if (price_rule.entitled_product_ids.length > 0) {
    for (i = 0; i < cart.items.length; i++) {
      if (price_rule.entitled_product_ids.indexOf(cart.items[i].product_id) > -1) {
        entitledItems.push(cart.items[i]);
        entitledItemsCount += cart.items[i].quantity;
        entitledItemsPrice += cart.items[i].quantity * cart.items[i].price;
      }
    }
  } else if (price_rule.entitled_collection_ids.length > 0) {
    for (i = 0; i < cart.items.length; i++) {
      for (j = 0; j < product_collections[cart.items[i].product_id].length; j++) {
        if (price_rule.entitled_collection_ids.indexOf(product_collections[cart.items[i].product_id][j] * 1) > -1) {
          entitledItems.push(cart.items[i]);
          entitledItemsCount += cart.items[i].quantity;
          entitledItemsPrice += cart.items[i].quantity * cart.items[i].price;
        }
      }
    }
  } else {
    entitledItems = cart.items;
    entitledItemsCount = cart.item_count;
    entitledItemsPrice = cart.original_total_price;
  }

  if (entitledItemsCount == 0) {
    discount.error = 'Koszyk nie spełnia wymagań dla wpisanego kodu';
    //deactivateDiscount('Koszyk nie spełnia wymagań dla wpisanego kodu');
    return;
  }

  if (price_rule.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity != null) {
    if (price_rule.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity > entitledItemsCount) {
      discount.error = 'Koszyk nie spełnia wymagań dla wpisanego kodu';
      //deactivateDiscount('Koszyk nie spełnia wymagań dla wpisanego kodu');
      return;
    } else {
      entitledQuantity = Math.floor(entitledItemsCount / (price_rule.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity + price_rule.prerequisite_to_entitlement_quantity_ratio.entitled_quantity));
      if (entitledQuantity == 0) {
        discount.error = 'Koszyk nie spełnia wymagań dla wpisanego kodu';
        //deactivateDiscount('Koszyk nie spełnia wymagań dla wpisanego kodu');
        return;
      }
      entitledItemsPrice = 0;
      sortByKey(entitledItems, 'price')
      for (i = 0; i < entitledItems.length; i++) {
        if (entitledQuantity >= entitledItems[i].quantity) {
          entitledItemsPrice += entitledItems[i].quantity * entitledItems[i].price;
          entitledQuantity -= entitledItems[i].quantity;
        } else {
          entitledItemsPrice += entitledQuantity * entitledItems[i].price;
          entitledQuantity = 0;
        }
      }
      discount.value = entitledItemsPrice / 100 * (price_rule.value / 100);
      //activateDiscount();        
      return;
    }
  }

  if ((price_rule.prerequisite_quantity_range != null && price_rule.prerequisite_quantity_range.greater_than_or_equal_to > entitledItemsCount) ||
    (price_rule.prerequisite_subtotal_range != null && price_rule.prerequisite_subtotal_range.greater_than_or_equal_to > entitledItemsPrice / 100)) {
    discount.error = 'Koszyk nie spełnia wymagań dla wpisanego kodu';
    //deactivateDiscount('Koszyk nie spełnia wymagań dla wpisanego kodu');
  } else {
    if (price_rule.target_type == 'shipping_line') {
      // shippingDiscount = 100;
      // if (price_rule.prerequisite_shipping_price_range != null) {
      //   shippingDiscount = price_rule.prerequisite_shipping_price_range.less_than_or_equal_to;
      //   if (shippingDiscount < 1) {
      //     shippingDiscount = 1;
      //   } else if (shippingDiscount > 100) {
      //     shippingDiscount = 100;
      //   }
      // }

      // if (shippingCost > 0) {
      //   discount.shipping_discount = shippingCost * shippingDiscount / 100 * (-1); //Math.min(shippingCost, shippingDiscount) * (-1);
      //   discount.value = 0;
      //   //activateDiscount();
      //   console.log('shipping_line' + discount.shipping_discount);
      // } else {
      discount.error = 'Tego kodu użyj po wyborze formy dostawy';
      return;
      // }
    } else if (price_rule.value_type == 'percentage' && price_rule.target_type != 'shipping_line') {
      discount.value = entitledItemsPrice / 100 * (price_rule.value / 100);
      console.log('percentage' + discount.value);
      //activateDiscount();
    } else if (price_rule.value_type == 'fixed_amount') {
      discount.value = price_rule.value / 1;
      console.log('fixed_amount' + discount.value);
      //activateDiscount();
    }
    discount.error = null;
  }
}